import React from 'react';
import PropTypes from 'prop-types';
import { useScript } from '../hooks/useScript';

const setLinkedinIdScript = {
  async: false,
  type: 'text/javascript',
  text: 'var _linkedin_data_partner_id = "30812";',
};

const scriptAttributes = {
  async: true,
  type: 'text/javascript',
  src: 'https://snap.licdn.com/li.lms-analytics/insight.min.js',
};

const REQUIRED_CONSENT_LEVEL = 2;

export const useLinkedinInsight = consentLevel => {
  const hasConsent = consentLevel >= REQUIRED_CONSENT_LEVEL;
  useScript('head', setLinkedinIdScript, hasConsent);
  useScript('head', scriptAttributes, hasConsent);
};

export const LinkedinInsight = ({ consentLevel }) => {
  useLinkedinInsight(consentLevel);
  return null;
};

LinkedinInsight.propTypes = {
  consentLevel: PropTypes.number
};
